import React from 'react'
import './Impressum.css'

export default function Impressum() {
  return (
 <div className="impressum">
  <div className="iText">
    <h2 className="i">Anbieter</h2>
    <br />
    <p>Anbieterkennzeichnung nach §5 Telemediengesetz</p>
    <br />
    <h3>Adresse:</h3>
    <p>
      Hallo: Verein zur Förderung raumöffnender Kultur e.V. <br />
      Süderstraße 112 <br />
      20537 Hamburg
    </p>
    <br />
    <h3>Registereintrag:</h3>
    <p>
      Eintragung im Vereinsregister. <br />
      Registergericht: Hamburg <br />
      Registernummer: VR 22565
    </p>
    <br />
    <h3>Vertreten durch den Vorstand:</h3>
    <p>
      Julia Marie Englert, Nuriye Tohermes, Georg von Rüdiger, <br />
      Daniel Dominguez Teruel und Ariane Burghard
    </p>
  </div>
</div>
  )
}
